<template>
  <div class="header-flex">
    <div class="header">
      <h2>智芯之家</h2>
    </div>
    <div class="nav-items">
      <h4 class="gap" @click="handleConnectSerial" :class="{ 'connected-style': isSerialConnected }">
        <i class="fas fa-plus"></i>{{ isSerialConnected ? '串口已连接' : '添加串口设备' }}
      </h4>
      <h4 class="btulet" @click="handleConnectBlel" :class="{ 'bel-style': isBleConnected }">
        <i class="fas fa-plus"></i>{{ isBleConnected ? '蓝牙灯控已连接' : '蓝牙灯控' }}
      </h4>
    </div>
  </div>

  <div class="gallery">
    <div class="image-container" v-if="showSerialDeviceCard" @click="navigateToSerialDeviceControl">
      <img :src="image.src" alt="图片2">
      <div class="description">
        <p class="text-line">智芯X.PAD - v{{ serialDeviceInfo.version || 'N/A' }}</p>
        <p class="icon-line">
          <span style="color: rgb(0, 245, 0)" id="batteryPercentage">{{ serialDeviceInfo.battery_level || 0 }}% </span>
          <i class="fas fa-battery-half" style="color: rgb(6, 255, 6);"></i>
          <i>
            <svg t="1720085179326" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2272" width="16" height="16">
              <path d="M932.352 310.272L434.688 0v402.944L145.92 222.72 91.648 307.2l324.096 204.8-324.096 204.8 54.272 87.04 288.768-180.224V1024l497.664-310.784L609.28 512zM537.088 184.32l201.728 125.952-201.728 125.952zM614.4 636.928l122.88 76.8-200.192 125.952v-251.904z" fill="#333333" p-id="2273"></path>
            </svg>
          </i>
        </p>
      </div>
    </div>
    <div class="image-container" v-else>
      <img :src="image.src" alt="图片2">
      <div class="description">
        <p class="text-line">智芯X.PAD</p>
        <p class="image-txt">当前无串口设备连接！请先添加设备！</p>
        <p class="icon-line"></p>
      </div>
    </div>

    <div class="image-container" v-if="showBleDeviceCard" @click="navigateToBleDeviceControl">
      <img :src="secondImage.src" alt="图片3" height="499" width="499">
      <div class="description">
        <p class="text-line">X.LIGHT-v{{ bleDeviceInfo.version || 'N/A' }}</p>
        <p class="icon-line">
          <i>
            <svg t="1720085179326" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2272" width="16" height="16">
              <path d="M932.352 310.272L434.688 0v402.944L145.92 222.72 91.648 307.2l324.096 204.8-324.096 204.8 54.272 87.04 288.768-180.224V1024l497.664-310.784L609.28 512zM537.088 184.32l201.728 125.952-201.728 125.952zM614.4 636.928l122.88 76.8-200.192 125.952v-251.904z" fill="#090df4" p-id="2273"></path>
            </svg>
          </i>
        </p>
      </div>
    </div>
    <div class="image-container" v-else>
      <img :src="secondImage.src" alt="图片3" height="499" width="499">
      <div class="description">
        <p class="text-line">智芯Y.PAD</p>
        <p class="image-txt">当前无蓝牙设备连接！请先添加设备！</p>
        <p class="icon-line"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
// 导入蓝牙 UUIDs
import { NUS_SERVICE_UUID } from '@/components/nordicUARTServiceUUIDs';

export default {
  name: 'LogNavComponent',
  data() {
    return {
      // 串口设备相关数据
      image: {
        src: require('@/assets/9.png'), // X.PAD 的图片
      },
      serialDeviceInfo: { // 用于存储串口设备的信息
        version: null,
        battery_level: null,
      },

      // 蓝牙灯控设备相关数据
      secondImage: {
        src: require('@/assets/zm.png'), // X.LIGHT 的图片
      },
      bleDeviceInfo: { // 用于存储蓝牙设备的信息
        version: null, // 您可能需要从蓝牙设备读取版本信息
        // 蓝牙设备通常不直接报告电池，但如果您有自定义服务，可以添加
      },
    };
  },
  mounted() {
    // 页面加载时，根据 Vuex 的状态初始化设备卡片显示
    this.updateSerialDeviceInfoFromStore();
    this.updateBleDeviceInfoFromStore();
  },
  computed: {
    // 从 Vuex 获取串口和蓝牙连接状态以及设备信息
    ...mapGetters([
      'getIsSerialConnected',  // 串口连接状态 (已更名)
      'getDeviceInfo',         // 串口设备信息 (已更名)
      'getGattServer',         // 蓝牙 GATT Server (连接成功后 Vuex 会有值)
      'getIsBleConnected'      // 蓝牙连接状态 (已更名)
    ]),

    // 串口连接状态的计算属性
    isSerialConnected() {
      return this.getIsSerialConnected;
    },
    showSerialDeviceCard() {
      return this.isSerialConnected; // 如果串口连接，显示设备卡片
    },

    // 蓝牙连接状态的计算属性
    isBleConnected() {
      return this.getIsBleConnected; // 直接使用 Vuex 的蓝牙连接状态
    },
    showBleDeviceCard() {
      return this.isBleConnected; // 如果蓝牙连接，显示设备卡片
    },
  },
  methods: {
    // 映射 Vuex action，用于串口连接逻辑
    ...mapActions([
      'connectSerial', // 假设 connectSerial action 会处理串口连接并更新 Vuex 状态
    ]),
    // 映射 Vuex mutation，用于设置蓝牙 GATT Server
    ...mapMutations([
      'SET_GATT_SERVER', // 用于将连接的 GATT Server 保存到 Vuex (已更名)
      'SET_BLE_DEVICE_INFO', // 用于设置蓝牙设备信息 (新增)
    ]),

    // --- 串口连接相关 ---
    updateSerialDeviceInfoFromStore() {
      // 当 Vuex 的 getDeviceInfo 变化时，更新本地数据
      if (this.getDeviceInfo) {
        this.serialDeviceInfo.battery_level = this.getDeviceInfo.battery_level;
        this.serialDeviceInfo.version = this.getDeviceInfo.version;
      } else {
        // 如果串口未连接或信息为空，则重置
        this.serialDeviceInfo.battery_level = null;
        this.serialDeviceInfo.version = null;
      }
    },
    async handleConnectSerial() {
      // 调用 Vuex 的 connectSerial action 来处理连接逻辑
      await this.connectSerial();
    },
    navigateToSerialDeviceControl() {
      if (this.isSerialConnected) {
        console.log('导航到串口设备控制页面');
        this.$router.push('/upgradePage'); // 您的串口设备控制页面路由
      } else {
        alert('请先连接串口设备！');
      }
    },

    // --- 蓝牙连接相关 ---
    updateBleDeviceInfoFromStore() {
        // 这里只是一个模拟，实际的蓝牙设备信息（如版本号）需要从蓝牙设备读取
        // 这通常会在蓝牙特性初始化后进行
        if (this.isBleConnected && this.getGattServer) {
            // 假设您在蓝牙连接成功后，在某个地方（例如 light-control 组件）读取并设置了 bleDeviceInfo
            // 如果 bleDeviceInfo 在 Vuex 中有值，可以直接取用
            if (this.$store.getters.getBleDeviceInfo) {
                this.bleDeviceInfo.version = this.$store.getters.getBleDeviceInfo.version;
            } else {
                // 暂时给一个默认值，直到从设备实际读取到
                this.bleDeviceInfo.version = '1.0.0';
            }
        } else {
            this.bleDeviceInfo.version = null;
        }
    },
    async handleConnectBlel() {
      if (this.isBleConnected) {
        console.log('蓝牙灯控已连接，无需重复连接。');
        // 可选：如果用户点击已连接的按钮，可以提示是否断开连接
        // if (confirm('蓝牙设备已连接。要断开连接吗？')) {
        //   this.disconnectBlel();
        // }
        return;
      }

      console.log('正在请求蓝牙设备...');
      try {
        const device = await navigator.bluetooth.requestDevice({
          // 过滤条件：强烈建议使用 service UUID 或 namePrefix 来过滤设备
          // 这里使用 NUS_SERVICE_UUID 来查找您的灯带设备
          filters: [{ services: [NUS_SERVICE_UUID] }],
          // 如果您的设备还有其他需要访问的服务，也请添加到 optionalServices
          optionalServices: [NUS_SERVICE_UUID]
        });

        console.log('选中的蓝牙设备:', device.name);
        // 连接设备 GATT 服务器
        const server = await device.gatt.connect();

        if (server.connected) {
          console.log('蓝牙设备已连接:', server);
          // 将连接的 GATT 服务器保存到 Vuex store
          this.SET_GATT_SERVER(server); // 使用更名后的 mutation
          // 模拟设置蓝牙设备信息，实际应从设备读取
          this.SET_BLE_DEVICE_INFO({ version: '1.0.0' }); // 示例：将版本信息存储到 Vuex
          this.updateBleDeviceInfoFromStore(); // 更新 UI 上的设备信息
        } else {
          console.error('蓝牙设备连接失败。');
          alert('蓝牙设备连接失败，请重试。');
        }
      } catch (error) {
        if (error.name === 'NotFoundError') {
          console.warn('未找到蓝牙设备或用户取消。');
          alert('未找到蓝牙设备或您取消了选择。');
        } else {
          console.error('蓝牙连接过程中发生错误:', error);
          alert(`蓝牙连接错误: ${error.message}`);
        }
      }
    },

    // 可选：蓝牙断开连接方法 (如果需要用户主动断开)
    // disconnectBlel() {
    //   if (this.getGattServer && this.getGattServer.connected) {
    //     this.getGattServer.device.disconnect();
    //     // Vuex 的 setGattServer mutation 会在 gattserverdisconnected 事件中自动处理清理
    //     console.log('蓝牙设备已请求断开连接。');
    //   } else {
    //     console.log('蓝牙未连接。');
    //   }
    // },

    navigateToBleDeviceControl() {
      if (this.isBleConnected) {
        console.log('导航到蓝牙灯控页面');
        this.$router.push('/secondUpgradePage'); // 您的蓝牙灯控页面路由
      } else {
        alert('请先连接蓝牙设备！');
      }
    },
  },
  watch: {
    // 监听 Vuex 中串口设备信息的 getters 变化
    getDeviceInfo: { // 监听 getDeviceInfo
      handler() {
        this.updateSerialDeviceInfoFromStore();
      },
      deep: true,
      immediate: true, // 立即执行一次，确保组件初次加载时状态正确
    },
    // 监听 Vuex 中蓝牙连接状态的 getters 变化
    getIsBleConnected: { // 监听 getIsBleConnected
      handler() {
        this.updateBleDeviceInfoFromStore(); // 当连接状态变化时，更新蓝牙设备信息
      },
      immediate: true, // 立即执行一次
    },
    // 监听蓝牙设备信息的 getters 变化，如果您的蓝牙设备会动态更新信息
    getBleDeviceInfo: {
      handler() {
        this.updateBleDeviceInfoFromStore();
      },
      deep: true,
      immediate: true,
    }
  },
};
</script>

<style scoped>
/* 保持您原有的样式 */
.header-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.connected-style {
  color: rgb(72, 255, 0); /* 串口连接成功颜色 */
}
.bel-style {
  color: #022af3; /* 蓝牙连接成功颜色 */
}
.nav-items {
  display: flex;
  gap: 10px;
  padding-top: 12px;
  flex-direction: column;
  padding-right: 20px;
}

.gap {
  margin: 0 10px;
}
.btulet {
  margin: 0 10px;
  padding-top: 18px;
}

.gallery {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 200px; /* 添加间距以使图片并排显示 */
  margin-top: 150px;
}

.image-container {
  position: relative;
  width: 500px; /* Adjust as needed */
  height: 600px; /* Adjust as needed */
  overflow: hidden;
  cursor: pointer;
}

.image-txt {
  color: red;
  font-size: 20px;
  font-weight: bold;
}

.active {
  opacity: 1;
}

.inactive {
  opacity: 1;
}

.description {
  position: absolute;
  bottom: 16px;
  left: 0;
  width: 100%;
  margin-bottom: -30px;
  background-color: rgba(216, 216, 216, 0.5);
  color: #727272;
  text-align: center;
  font-weight: bold;
}

.text-line {
  margin-bottom: 5px;
}

.icon-line {
  font-size: 15px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 80px;
  padding-top: 0px;
  margin-top: -12px;
}
</style>